import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisons = [{
  icon: '⏰',
  without: '3-5 hs/semana planificando desde cero',
  with: '10 min/semana. El resto es enseñar.'
}, {
  icon: '😓',
  without: 'Siempre las mismas posturas',
  with: '60+ clases distintas listas para dar'
}, {
  icon: '💸',
  without: 'Alumnos que abandonan sin saber por qué',
  with: 'Progresión → retención visible mes a mes'
}, {
  icon: '📋',
  without: 'Sin progresión clara de nivel a nivel',
  with: '6 tomos con progresión anual estructurada'
}, {
  icon: '😨',
  without: 'Alumno con lesión o condición especial = pánico',
  with: 'Yoga Terapéutico Pro → adaptación segura y profesional'
}, {
  icon: '👥',
  without: 'Niveles mezclados = caos en clase',
  with: 'Variaciones en 3 niveles para cada postura'
}, {
  icon: '🧘',
  without: 'Sin meditaciones ni cierres estructurados',
  with: '8 meditaciones guiadas con guión listo'
}, {
  icon: '📱',
  without: 'Sin sistema de comunicación profesional',
  with: '30 días de contenido + 18 flyers listos'
}, {
  icon: '💼',
  without: 'Sin identidad profesional visible',
  with: 'Sistema que justifica cobrar más y retener más'
}];
export function ComparisonTable() {
  return <section className="py-24 bg-gray-50" data-id="element-50">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-51">
        <div className="text-center mb-16" data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900" data-id="element-53">
            EL COSTO DE NO TENER UN SISTEMA
          </h2>
        </div>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200" data-id="element-54">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-55">
            <div className="p-6 text-center font-bold text-gray-500 uppercase tracking-wider text-sm" data-id="element-56">
              SIN YOGA RESUELTA
            </div>
            <div className="p-6 text-center font-bold text-yoga-purple-700 uppercase tracking-wider text-sm bg-yoga-purple-50" data-id="element-57">
              CON YOGA RESUELTA
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-58">
            {comparisons.map((item, index) => <motion.div key={index} className="grid grid-cols-2 relative" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} data-id="element-59">
                {/* Center Icon */}
                <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm border border-gray-100 z-10 text-lg" data-id="element-60">
                  {item.icon}
                </div>

                <div className="p-6 pr-8 text-right flex flex-col justify-center text-gray-600" data-id="element-61">
                  <span className="text-sm md:text-base" data-id="element-62">{item.without}</span>
                </div>

                <div className="p-6 pl-8 bg-yoga-purple-50/30 flex flex-col justify-center font-medium text-yoga-purple-900" data-id="element-63">
                  <span className="text-sm md:text-base" data-id="element-64">{item.with}</span>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}